import client from './client';

export const recoverMessageMedia = messageId => client.post(`/v1/messages/${messageId}/media/recover/`, {}, { timeout: 70000 });

export const listMessages = (contactId, before) =>
  client.get('/v1/messages/', { params: { contact: contactId, before } });

export const sendMessage = (sessionId, chatId, message) =>
  client.post('/v1/messages/send/', { session_id: sessionId, chat_id: chatId, message });

export const listContacts = (params = {}) => client.get('/v1/messages/contacts/', { params });
// La chat con un numero (biglietto di un contatto inviato): esistente o nuova.
export const openContactChat = (connection, numero, nome = '') => client.post('/v1/messages/contacts/apri/', { connection, numero, nome });

export const sendMedia = (sessionId, chatId, file, caption = '') => {
  const formData = new FormData();
  formData.append('session_id', sessionId);
  formData.append('chat_id', chatId);
  formData.append('file', file);
  if (caption) formData.append('caption', caption);
  return client.post('/v1/messages/send-media/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const fetchFromWhatsApp = (sessionId, chatId, limit = 30) =>
  client.post('/v1/messages/fetch/', { session_id: sessionId, chat_id: chatId, limit });

export const reactToMessage = (sessionId, messageId, emoji) =>
  client.post('/v1/messages/react/', { session_id: sessionId, message_id: messageId, emoji });

// Modifica di un messaggio inviato da Wozzap (solo da qui e nei primi 15 minuti: regola di WhatsApp).
export const editMessage = (messageId, message) => client.post('/v1/messages/edit/', { message_id: messageId, message });

export const replyToMessage = (sessionId, messageId, message) =>
  client.post('/v1/messages/reply/', { session_id: sessionId, message_id: messageId, message });

export const forwardMessage = (sessionId, messageId, chatId) =>
  client.post('/v1/messages/forward/', { session_id: sessionId, message_id: messageId, chat_id: chatId });

// Con `author` è la foto di chi scrive dentro quella chat (un gruppo), non della chat.
export const getContactAvatar = (contactId, refresh = false, author = '') =>
  client.get(`/v1/messages/contacts/${contactId}/avatar/`,
    { params: { ...(refresh ? { refresh: 1 } : {}), ...(author ? { author } : {}) } });

export const getLinkPreview = messageId => client.get(`/v1/messages/${messageId}/anteprima-link/`);
